import React from "react";
import { useTranslation } from "react-i18next";

//Custom
import { getCallDirectLayers, getCallGroupedLayers, getOnlyGroupLayers } from "@/lib/olHelpers";
import { GroupLayer } from "@/components/Map/Layers";
import GeoLayer from "./GeoLayer";
import GeoLayerCombined from "./GeoLayerCombined";

//OL
import OlCollection from "ol/Collection";
import OlBaseLayer from "ol/layer/Base";
import OlLayerGroup from "ol/layer/Group";

type GeoAPILayersProps = {
  layersCollection: OlCollection<OlBaseLayer>;
  forceVisible?: boolean;
  isPrivate?: boolean;
};

function GeoAPILayers(props: GeoAPILayersProps) {
  const { t } = useTranslation();

  const { layersCollection, forceVisible, isPrivate } = props;

  return layersCollection ? (
    <>
      {getOnlyGroupLayers(layersCollection.getArray()).map((layer: OlLayerGroup, i: number) => {
        return (
          <GroupLayer key={layer.get("id") + "-" + i} id={layer.get("id")} title={t(layer.get("title"))}>
            {getCallDirectLayers(layer.getLayers().getArray()).map((cl: OlBaseLayer, j: number) => {
              return <GeoLayer key={j} id={cl.get("id")} layer={cl} forceVisible={forceVisible} isPrivate={isPrivate} />;
            })}
            {getCallGroupedLayers(layer.getLayers().getArray()).map((cgl, k: number) => {
              return (
                <GeoLayerCombined key={k} id={cgl.call_group} layersCollection={new OlCollection(cgl.layers)} forceVisible={forceVisible} />
              );
            })}
          </GroupLayer>
        );
      })}
      {getCallDirectLayers(layersCollection.getArray()).map((l: OlBaseLayer, x: number) => {
        return <GeoLayer key={x} id={l.get("id")} layer={l} forceVisible={forceVisible} isPrivate={isPrivate} />;
      })}
      {getCallGroupedLayers(layersCollection.getArray()).map((gl, y: number) => {
        return <GeoLayerCombined key={y} id={gl.call_group} layersCollection={new OlCollection(gl.layers)} forceVisible={forceVisible} />;
      })}
    </>
  ) : null;
}

export default GeoAPILayers;
